import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleMarketingService {
  constructor(private router: Router) {}

  public initialize(): void {
    if (environment.production) {
      this.initializeGoogleAnalytics();
      this.initializeGoogleTagManager();
    }
  }

  private initializeGoogleAnalytics(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (
          event.url === '/authorization/welcome' ||
          event.url === '/show/dashboard'
        ) {
          (<any>window)?.gtag('js', new Date());
          (<any>window)?.gtag('config', 'UA-181247242-1', {
            page_path: event.url,
          });
        }
      });
  }

  private initializeGoogleTagManager(): void {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      (<any>j).async = true;
      (<any>j).src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-M6CKCW4');
  }
}
